export const getUrlParameter = (queryParamKey) => {
  if (typeof window === 'undefined'){
    return '';
  }
  const queryParamValue = new URLSearchParams(window.location.search).get(queryParamKey);
  return queryParamValue || '';
};

export default getUrlParameter;
